import { useEffect } from 'react'

import { useSelector } from 'react-redux'

import { makeSelectRole } from '@webapp/core/stores/global'
import { useFeatureFlag } from '@webapp/hooks'
import { IS_PROD } from '@webapp/infrastructure/envs'
import { PermissionGroupNames } from '@webapp/models'

// For UI at the bottom-right, where the Intercom launcher, Messenger and notifications sit.
export const useHideIntercom = (hidden: boolean) => {
  const FT_4880_ENABLE_INTERCOM = useFeatureFlag('FT_4880_ENABLE_INTERCOM')
  const role = useSelector(makeSelectRole())

  // The snippet defines window.Intercom in every environment, so mirror the boot gate in components/Intercom.
  const isIntercomEnabled =
    FT_4880_ENABLE_INTERCOM &&
    IS_PROD &&
    !!role &&
    PermissionGroupNames.SITE_ADMINISTRATOR !== role.name

  useEffect(() => {
    if (!hidden || !isIntercomEnabled || !window.Intercom) return undefined

    window.Intercom('update', { hide_default_launcher: true })
    window.Intercom('hide')
    window.Intercom('hideNotifications', true)

    return () => {
      // false forces the launcher on, so this assumes the workspace shows it to every booted user.
      window.Intercom?.('update', { hide_default_launcher: false })
      window.Intercom?.('hideNotifications', false)
    }
  }, [hidden, isIntercomEnabled])
}
